var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifyWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39413 27.224H25.7035C27.2328 27.144 28.4088 25.8413 28.3301 24.312C28.3128 24.0026 28.2461 23.6973 28.1288 23.412L18.4261 6.43064C17.6848 5.09064 15.9981 4.6053 14.6581 5.34797C14.2021 5.59864 13.8261 5.97464 13.5741 6.43064L3.87146 23.412C3.29546 24.8306 3.97813 26.4466 5.39546 27.024C5.68346 27.14 5.98746 27.2066 6.29679 27.224",
    fill: "#F98524"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39413 27.224H25.7035C27.2328 27.144 28.4088 25.8413 28.3301 24.312C28.3128 24.0026 28.2461 23.6973 28.1288 23.412L18.4261 6.43064C17.6848 5.09064 15.9981 4.6053 14.6581 5.34797C14.2021 5.59864 13.8261 5.97464 13.5741 6.43064L3.87146 23.412C3.29546 24.8306 3.97813 26.4466 5.39546 27.024C5.68346 27.14 5.98746 27.2066 6.29679 27.224",
    stroke: "#F98524",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.6931C15 21.1411 15.448 20.6851 16 20.6851C16.552 20.6851 17 21.1264 17 21.6784V21.6931C17 22.2451 16.552 22.6931 16 22.6931C15.448 22.6931 15 22.2451 15 21.6931Z",
    fill: "#F2F2F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.986 17.8618V13.7285",
    stroke: "#F2F2F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyWarning);
export default __webpack_public_path__ + "static/media/notify-warning.915de463.svg";
export { ForwardRef as ReactComponent };